import type { SpinResponse } from "@slot/client-engine";
import { fsFixtureFreeSpins } from "./fs_fixture_free_spins";

/**
 * Flat FEATURE fixture fallback — served only for a `requestedFeatureIdentifier` with no
 * keyed pool in `featureFixturesById` (see ../index.ts; this game's only buy has a keyed
 * pool, so this list is the safety net). The entry follows the canonical backend round shape.
 */
export function createFeatureFixtures(): SpinResponse[] {
  return [
    fsFixtureFreeSpins(),
  ];
}
